import React from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { FeatureBodyCopy } from '../../General/Feature/FeatureBodyCopy';
import { FeatureButton } from '../../General/Feature/FeatureButton';
import { FeatureHeader } from '../../General/Feature/FeatureHeader';
import { FeatureContent } from '../../General/Feature/FeatureContent';
import { FeatureLink } from '../../Marketing/FeatureLink';
import { CtaCard } from '../../General/CtaCard';
import { MobileBodyFeature } from './Mobile/MobileBodyFeature';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  sectionCopy: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '670px',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
}));

export const BodyFeature = ({
  feature,
  accentColor,
  selectedFeature,
  featureRef,
  index,
  special,
  firstSetNoOverview,
  home,
  homeCta,
  cardArray,
  noCards,
  noPaddingBottom,
  justify = 'space-evenly',
}) => {
  const {
    bodyHeader,
    bodySubHeader,
    image,
    videoVariant,
    ctaText,
    thumbnailVideoUrl,
    _rawBodyCopy,
    _key,
    ctaLink,
    internalLink,
    links,
    navatticPopUp = {},
  } = feature;

  const lg = useMediaQuery('(max-width: 1280px)');
  const med = useMediaQuery('(max-width: 960px)');
  const classes = useStyles();

  let padding = '4rem 0';
  if (med) padding = '0rem 0';
  if (noCards) padding = '4rem 0';
  if (firstSetNoOverview && index === 0) padding = '0 0 4rem 0';
  if (noPaddingBottom)
    padding = padding
      .replace(/4rem 0$/, '4rem 0 0 0')
      .replace(/0 0 4rem 0/, '0 0 0 0');

  const direction =
    (cardArray?.findIndex((el) => el._key === feature._key) ?? index) % 2 ===
      0 || special
      ? 'row-reverse'
      : 'row';

  return (
    <>
      <div
        ref={selectedFeature === _key ? featureRef : null}
        style={{
          display: 'flex',
          flexDirection: med ? 'column' : direction,
          justifyContent: justify,
          alignItems: 'center',
          padding,
          position: 'relative',
          zIndex: 3,
          gap: '2rem',
          flexWrap: med ? 'wrap' : 'nowrap',
          paddingBottom: noCards ? '0' : '4rem',
        }}
      >
        <FeatureContent
          image={image}
          thumbnailVideoUrl={thumbnailVideoUrl}
          videoVariant={videoVariant}
          computedDirection={direction}
        />

        {/* ⛔️ Removed flex: 1 here */}
        <div className={classes.sectionCopy}>
          <FeatureHeader
            bodyHeader={bodyHeader}
            bodySubHeader={bodySubHeader}
          />
          <FeatureBodyCopy _rawBodyCopy={_rawBodyCopy} />
          {links?.length ? (
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '1rem',
                paddingTop: '2rem',
              }}
            >
              {!med
                ? links.map((link, index) => (
                    <FeatureLink link={link} key={index} />
                  ))
                : links.map((link, index) => (
                    <MobileBodyFeature link={link} key={index} />
                  ))}
            </div>
          ) : (
            <FeatureButton
              ctaLink={ctaLink}
              internalLink={internalLink}
              ctaText={ctaText}
              accentColor={accentColor}
              navatticPopUp={navatticPopUp}
            />
          )}
        </div>
      </div>

      {home && index === 0 && homeCta?.ctaHeader ? (
        <CtaCard
          background={homeCta.ctaBackground}
          header={homeCta.ctaHeader}
          subheader={homeCta.ctaSubheader}
          ctaText={homeCta.ctaText}
          ctaLink={homeCta.ctaLink}
          internalLink={homeCta.internalLink}
        />
      ) : null}
    </>
  );
};
